<div class="mobile-header" [ngClass]="{'opened': state}">
  <div class="mobile-header__top">
    <div class="mobile-header__search" (click)="openGlobalSearch()">
      <div class="mobile-header__search-icon"><brt-icon [icon]="'search'"></brt-icon></div>
      <input type="text" placeholder="Suche" [(ngModel)]="searchText" />
    </div>
    <div class="mobile-header__login" brtItemActions [items]="loginActionMenu"><brt-button [title]="'Anmelden'" [color]="'red'"></brt-button></div>
  </div>

  <div class="mobile-header__menu-item" #professionItems>
    <div class="mobile-header__menu-item-title" (click)="toggleMenuItem(professionItems)">
      <span>{{'MENU.PROFESSIONS.MAIN_TITLE' | translate }}</span>
      <span><brt-icon [icon]="'reg-chevron-down'"></brt-icon></span>
    </div>
    <div class="mobile-header__menu-item-content-wrapper">
      <div class="mobile-header__menu-item-content">
        <div class="mobile-header__menu-item-content-sub-item" *ngFor="let item of menuItems.professions">
          <brt-submenu-item [target]="item.target" [link]="item.link" [icon-url]="item.iconUrl" [title]="item.title | translate" [abstract]="item.abstract | translate"></brt-submenu-item>
        </div>
      </div>
    </div>
  </div>

  <div routerLink="/einblicke" class="mobile-header__menu-item">
    <div class="mobile-header__menu-item-title">
      <span>{{'MENU.INSIGHTS.MAIN_TITLE' | translate }}</span>
    </div>
  </div>

  <div class="mobile-header__menu-item" routerLink="/anbieter">
    <div class="mobile-header__menu-item-title">
      <span>{{ "MENU.PROVIDERS.MAIN_TITLE" | translate }}</span>
    </div>
  </div>

  <div class="mobile-header__menu-item" routerLink="/jobboerse">
    <div class="mobile-header__menu-item-title">
      <span>{{"MENU.JOBS.MAIN_TITLE" | translate }}</span>
    </div>
  </div>

  <div class="mobile-header__menu-item" #infoItems>
    <div class="mobile-header__menu-item-title" (click)="toggleMenuItem(infoItems)">
      <span>{{"MENU.INFO_OFFERS.MAIN_TITLE" | translate }}</span>
      <span><brt-icon [icon]="'reg-chevron-down'"></brt-icon></span>
    </div>
    <div class="mobile-header__menu-item-content-wrapper">
      <div class="mobile-header__menu-item-content">
        <div class="mobile-header__menu-item-content-sub-item" *ngFor="let item of menuItems.infos">
          <brt-submenu-item [target]="item.target" [link]="item.link" [icon-url]="item.iconUrl" [title]="item.title | translate" [abstract]="item.abstract | translate"></brt-submenu-item>
        </div>
      </div>
    </div>
  </div>

  <div class="mobile-header__menu-item mobile-header__menu-item--icons" (click)="openSelfAssessmentOverlay()">
    <div class="mobile-header__menu-item-icon">
      <brt-wizard-icon></brt-wizard-icon>
    </div>
    <div class="mobile-header__menu-item-label">Anforderungen-Check</div>
  </div>

  <div class="mobile-header__menu-item mobile-header__menu-item--icons" brtItemActions [items]="bookmarksActionMenu" [title]="'Deine Merkliste'">
    <div class="mobile-header__menu-item-icon">
      <brt-favorites-icon [favoriteItemsNumber]="favoriteItemsNumber"></brt-favorites-icon>
    </div>
    <div class="mobile-header__menu-item-label">Merkliste</div>
  </div>
</div>
